var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFalabellaGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9365 41.6354C24.7667 41.6354 6.90039 36.8289 6.90039 30.8989C6.90039 24.9748 24.7667 20.1697 30.9365 20.1697C37.099 20.1697 42.0984 24.9748 42.0984 30.8989C42.0984 36.8289 37.099 41.6354 30.9365 41.6354Z",
    fill: "#CFDBEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4297 24.2038C21.4201 21.8577 11.7608 11.9389 14.2027 8.08306C16.6374 4.22721 30.2412 7.88362 34.258 10.237C38.2677 12.5705 39.5536 17.6031 37.1117 21.4589C34.677 25.322 29.4465 26.5512 25.4297 24.2038Z",
    fill: "#CFDBEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0547 21.6111C23.3327 22.7571 24.527 23.6738 25.433 24.2038C29.3238 26.4776 34.3535 25.3957 36.8779 21.8146C35.1573 20.7726 33.1203 20.1697 30.9375 20.1697C28.8984 20.1697 25.5817 20.6945 22.0547 21.6111Z",
    fill: "#B8C5D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalabellaGrey);
export default __webpack_public_path__ + "static/media/falabella-grey.c468e172373b05c730518a9731519b37.svg";
export { ForwardRef as ReactComponent };